var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.student
    ? _c(
        "SoliAvatarBtn",
        {
          attrs: {
            title: _vm.student.name,
            subtitleBottom: _vm.student.email ?? null,
            avatar: _vm.student.profile_photo_url,
            blue: "",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("input", _vm.student)
            },
          },
        },
        [
          [
            _vm.hasPaymentMethod
              ? _c(
                  "div",
                  { staticClass: "flex justify-start" },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("credit_card"),
                    ]),
                    _vm._v(
                      _vm._s(`****${_vm.student.pm_last_four}`) + "\n        "
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }